module.exports = __webpack_public_path__ + "img/logo_easyparcel_long.4f8d3bb9.png";